import { forwardRef, type Ref, type SVGProps } from "react";
const IconCloseFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M25.967 8.957A2 2 0 0 0 23.14 6.13l-7.207 7.207L8.86 6.265a2 2 0 0 0-2.828 2.828l7.07 7.071L6.169 23.1a2 2 0 1 0 2.829 2.829l6.935-6.936 7.071 7.072a2 2 0 1 0 2.828-2.829l-7.07-7.07z" /></svg>;
const ForwardRef = forwardRef(IconCloseFilledSVG);
ForwardRef.displayName = "IconCloseFilled";
export { ForwardRef as IconCloseFilled };